import { Box, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { formatEventTime } from 'src/meetings/utils/date-utils';

type Props = {
  scheduledStartAt: string;
  scheduledEndAt: string;
  startAt: string | null;
  endAt: string | null;
};

export const EventTimeCard = ({ scheduledStartAt, scheduledEndAt, startAt, endAt }: Props) => {
  const startDate = new Date(scheduledStartAt);
  const formattedDate = startDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
  const timeRange = formatEventTime(scheduledStartAt, scheduledEndAt);

  const displayText =
    startAt && endAt
      ? `Meeting completed on ${formattedDate}, ${timeRange}`
      : `Meeting scheduled for ${formattedDate}, ${timeRange}`;

  return (
    <Box
      bg="success.2"
      py="xxxs"
      px="xxs"
      style={{
        borderRadius: '4px',
        display: 'inline-block',
      }}
    >
      <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.10">
        {displayText}
      </Text>
    </Box>
  );
};
